<app-data-grid
  [mode]="locked ? 'view' : 'edit'"
  [state]="state"
  [fontSize]="fontSize"
  (valueChange)="cacheChanges()"
  [columns]="columns"
  [columnGroups]="columnGroups"
  [dataItems]="changeset"
  [filterable]="'menu'"
  (dataStateChange)="onDataStateChange($event)"
  (filterChange)="filterChanged($event)"
>
  <ng-template
    filterTemplate
    let-column="column"
    let-filterService="filterService"
    field="itemName"
  >
    <app-custom-filter
      [view]="type"
      [restaurantId]="restaurantId"
      [filter]="state.filter"
      [preselected]="filterCache.get(column.field) || []"
      [productType]="productTypeId"
      (filterChanged)="
        onCustomFilterChange(column.field, $event, filterService)
      "
      [field]="column.field"
      [type]="column.type"
    ></app-custom-filter>
  </ng-template>

  <ng-template
    filterTemplate
    let-column="column"
    let-filterService="filterService"
    field="plu"
  >
    <app-custom-filter
      [view]="type"
      [restaurantId]="restaurantId"
      [filter]="state.filter"
      [preselected]="filterCache.get(column.field) || []"
      [productType]="productTypeId"
      (filterChanged)="
        onCustomFilterChange(column.field, $event, filterService)
      "
      [field]="column.field"
      [type]="column.type"
    ></app-custom-filter>
  </ng-template>

  <ng-template
    filterTemplate
    let-column="column"
    let-filterService="filterService"
    field="parItemId"
  >
    <app-custom-filter
      [view]="type"
      [restaurantId]="restaurantId"
      [filter]="state.filter"
      [preselected]="filterCache.get(column.field) || []"
      [productType]="productTypeId"
      (filterChanged)="
        onCustomFilterChange(column.field, $event, filterService)
      "
      [field]="column.field"
      [type]="column.type"
    ></app-custom-filter>
  </ng-template>

  <ng-template
    columnTemplate
    field="itemName"
    let-row="row"
    let-column="column"
  >
    <span class="k-d-flex k-gap-md k-align-items-center">
      <app-column [data]="row" [column]="column" [fontSize]="fontSize">
      </app-column>
      <button
        *ngIf="row.status == 'Pending Pricing'"
        kendoButton
        [title]="'This item is pending sync to PAR'"
        class="m-l-4 info-bg badge-button"
        size="small"
        rounded="full"
      >
        Pending
      </button>

      <button
        *ngIf="row.hasDirty()"
        kendoButton
        [title]="'This item has unsaved changes'"
        class="m-l-4 warning-bg badge-button"
        size="small"
        rounded="full"
      >
        Unsaved
      </button>

      <button
        *ngIf="row.status == 'Scheduled Pricing'"
        kendoButton
        [title]="'This item is scheduled to sync with PAR'"
        class="m-l-4 success-bg badge-button"
        size="small"
        rounded="full"
      >
        Scheduled
      </button>
    </span>
  </ng-template>

  <ng-template
    columnTemplate
    field="deliveryPrice"
    let-row="row"
    let-column="column"
  >
    <p
      *ngIf="row.deliveryPrice == null"
      [style.textAlign]="column.align || 'center'"
      [style.fontSize.rem]="fontSize"
      class="m-0 italic-text"
      kendoTooltip
      title="In-store price applied by default"
    >
      {{ row.itemPrice | currency: "USD" }}
    </p>
    <app-column
      [fontSize]="fontSize"
      [data]="row"
      [column]="column"
      *ngIf="row.deliveryPrice != null"
    >
    </app-column>
  </ng-template>

  <ng-template     
    columnTemplate
    field="newDeliveryPrice"
    let-row="row"
    let-column="column">
      <app-editable-column
      *ngIf="!locked"
      kendoTooltip
        [title]="row.isDeliveryAvailable == false ? 'This item is not available for delivery pricing.': ''"
       [fontSize]="fontSize"
       [dataItem]="row"
       [column]="column"
       (valueChange)="onValueChange($event.dataItem, $event.field)"
       [placeholder]="row.isDeliveryAvailable == false ? 'N/A' : ''"
       [disabled]="row.isDeliveryAvailable == false"
     ></app-editable-column>

     <app-column
      *ngIf="locked"
       [fontSize]="fontSize"
       [data]="row"
       [column]="column"
       ></app-column>
  </ng-template>

  <ng-template
    columnTemplate
    field="itemPriceLight"
    let-row="row"
    let-column="column"
  >
    <p
      *ngIf="row.itemPriceLight == null"
      [style.textAlign]="column.align || 'center'"
      [style.fontSize.rem]="fontSize"
      class="m-0 italic-text"
      kendoTooltip
      title="This item does not have a Light modifier set up in PAR."
    >
      N/A
    </p>
    <app-column
      [fontSize]="fontSize"
      [data]="row"
      [column]="column"
      *ngIf="row.itemPriceLight != null"
    >
    </app-column>
  </ng-template>

  <ng-template
    columnTemplate
    field="newPriceLight"
    let-row="row"
    let-column="column"
  >
    <app-editable-column
      *ngIf="!locked && !row.locked"
      kendoTooltip
      [title]="
        row.itemPriceLight == null
          ? 'This item does not have a Light modifier set up in PAR.'
          : ''
      "
      [fontSize]="fontSize"
      [dataItem]="row"
      [column]="column"
      (valueChange)="onValueChange($event.dataItem, $event.field)"
      [placeholder]="row.itemPriceLight == null ? 'N/A' : ''"
      [disabled]="row.itemPriceLight == null"
    ></app-editable-column>

    <app-column
      *ngIf="locked || row.locked"
      [fontSize]="fontSize"
      [data]="row"
      [column]="column"
    ></app-column>
  </ng-template>

  <ng-template #noRecordsTemplate>
      <p *ngIf="!newFeatures.includes(productTypeId)">There is no data that matches the current filter settings.</p>
      <p *ngIf="newFeatures.includes(productTypeId)">This feature is coming soon for the selected tier. We will send a future communication with further details.</p>
  </ng-template>
</app-data-grid>
